"use client";

import React, { createContext, useState } from "react";

type SignUpUser = {
    firstName: string;
    lastName: string;
};

type SignUpBusiness = {
    name: string;
    registrationNumber: string;
};

type SignUpContextType = {
    user?: SignUpUser;
    business?: SignUpBusiness;
    setUser: React.Dispatch<React.SetStateAction<SignUpUser | undefined>>;
    setBusiness: React.Dispatch<React.SetStateAction<SignUpBusiness | undefined>>;
};

export const SignUpContext = createContext<SignUpContextType>({
    setUser: () => {},
    setBusiness: () => {},
});

export const SignUpProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<SignUpUser | undefined>(undefined);
    const [business, setBusiness] = useState<SignUpBusiness | undefined>(undefined);

    return <SignUpContext.Provider value={{ user, business, setUser, setBusiness }}>{children}</SignUpContext.Provider>;
};
